import React from 'react';
import PropTypes from 'prop-types';
import { CTA, Image } from '../../../';
import { isValidArray } from '../../../utilities/validations';

const LearnCard = ({ data, className }) => (
	<div className={`learnCard grid-row-1 md:grid-row-2 grid grid-cols-1 ${className || ''}`}>
		{isValidArray(data.card?.[0]?.image) && (
			<Image
				data={data.card[0].image[0]}
				className='learnCard-image relative col-start-1 row-start-1 !block h-full w-full before:absolute before:bottom-0 before:left-0 before:z-1 before:h-10 before:w-full before:bg-gradient-to-t before:from-black before:to-transparent before:content-[""] md:before:content-none'
			/>
		)}

		<div className='learnCard-content relative col-start-1 row-start-2 flex w-full flex-col items-center justify-center bg-black p-6 max-md:pt-0 md:row-start-1 md:ml-auto md:h-full md:w-1/2 md:items-start md:bg-black/75'>
			{data.card?.[0]?.heading && (
				<div
					dangerouslySetInnerHTML={{ __html: data.card[0].heading }}
					className='learnCard-heading text-22px font-semibold text-white md:text-2xl'
				/>
			)}
			{data.card?.[0]?.description && (
				<div
					dangerouslySetInnerHTML={{ __html: data.card[0].description }}
					className='learnCard-description text-base text-white max-md:[&_li]:text-left [&_ul]:mb-6 [&_ul]:mt-4 [&_ul]:pl-5 max-md:[&_ul]:inline-block'
				/>
			)}
			{isValidArray(data.card?.[0]?.ctas) && (
				<CTA
					data={data.card[0].ctas[0]}
					className='learnCard-cta !w-auto text-white'
				/>
			)}
		</div>
	</div>
);

LearnCard.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default LearnCard;
